export const TEXTS = { TITLE: 'Превью медиафайла' };
